/* global grecaptcha */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { siteKey: String }

  connect = () => {
    this.form = this.element.form

    this.form.addEventListener('submit', this.checkCaptcha)
  }

  checkCaptcha = (event) => {
    event.preventDefault()

    // skip recaptcha in capybara tests
    const meta = document.querySelector('meta[name="Rails-Env"]')
    if (meta.content === 'test') {
      this.element.value = 'TEST_TOKEN'

      return this.form.submit()
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(this.siteKeyValue, { action: 'submit' }).then((token) => {
        this.element.value = token
        this.form.submit()
      })
    })
  }
}
